// src/modules/ga4/clickTracker.js

export class GA4ClickTracker {
 constructor() {
  this.isProduction = this.checkIfProduction();
  // スロットリングされたhandleClickを一度だけ定義
  this.throttledHandleClick = throttle(this.handleClick.bind(this), 100); // 100ミリ秒に一度だけ実行（繰り返しのクリック防止）
  this.initializeEventListeners();
  this.initializeMutationObservers(); // MutationObserversを初期化
 }

 // 環境を判定するメソッド
 checkIfProduction() {
  const hostname = window.location.hostname;
  const productionHosts = ["fuwaraku.jp"]; // 本番環境のドメイン名を追加
  return productionHosts.includes(hostname);
 }

 // 初期のイベントリスナーを設定
 initializeEventListeners() {
  const containers = document.querySelectorAll("[data-gtm-category]");
  //   console.log("initializeEventListeners - containers found:", containers);
  containers.forEach((container) => {
   if (!container.dataset.listenerAdded) {
    container.addEventListener("click", this.throttledHandleClick);
    container.dataset.listenerAdded = "true"; // リスナーが追加されたことを記録
   }
  });
 }

 // MutationObserverを使って監視するメソッド
 initializeMutationObservers() {
  // 通常は直接htmlに記述するが、jsなどの処理がある要素などは監視対象に追加。
  const targetNodes = document.querySelectorAll("#modal_search_filters, #menu, #root"); // 複数の監視対象を指定
  if (targetNodes.length === 0) {
   console.warn("MutationObserver - No target elements found");
   return;
  }

  targetNodes.forEach((targetNode) => {
   const observer = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
     if (mutation.type === "childList") {
      mutation.addedNodes.forEach((node) => {
       if (node.nodeType === 1 && node.hasAttribute("data-gtm-category")) {
        if (!node.dataset.listenerAdded) {
         //  console.log("MutationObserver - Adding event listener to new container:", node);
         node.addEventListener("click", this.throttledHandleClick);
         node.dataset.listenerAdded = "true"; // リスナーが追加されたことを記録
        }
       } else if (node.nodeType === 1) {
        const newContainers = node.querySelectorAll("[data-gtm-category]");
        newContainers.forEach((container) => {
         if (!container.dataset.listenerAdded) {
          //   console.log("MutationObserver - Adding event listener to new nested container:", container);
          container.addEventListener("click", this.throttledHandleClick);
          container.dataset.listenerAdded = "true"; // リスナーが追加されたことを記録
         }
        });
       }
      });
     }
    });
   });

   observer.observe(targetNode, { childList: true, subtree: true });
   //    console.log("MutationObserver - Observer initialized on:", targetNode);
  });
 }

 // クリックイベントの処理
 handleClick(event) {
  // 最も内側の[data-gtm-category]を取得
  const container = event.target.closest("[data-gtm-category]");
  if (!container) {
   return;
  }

  // イベントの伝播を停止して親リスナーに伝わらないようにする
  event.stopPropagation();

  const category = container.dataset.gtmCategory || "general";

  //   // デバッグ用：開発環境で、デバッグ時のみページ遷移を一時的に防ぐ。そのため、仮アップ時はこれを使用せずコメントアウトにすること。
  //   if (!this.isProduction) {
  //    event.preventDefault();
  //    console.log("handleClick - ページ遷移を防止（開発環境）");
  //   }

  const target = event.target.closest("a, button");
  if (!target) {
   return;
  }

  const trackingData = this.extractTrackingData(target, category);
  this.sendEventToGA4(trackingData);
 }

 // トラッキング情報を取得
 extractTrackingData(element, category) {
  const eventName = "click_event"; // 任意のイベント名
  const params = {
   category: category,
   element_type: element.tagName.toLowerCase(),
   element_id: element.id || "",
   element_class: element.className || "",
   element_text: this.getElementText(element) || "",
   element_url: element.href || "",
   // 必要に応じてカスタムパラメータを追加
  };
  return { eventName, params };
 }

 // 要素のテキストを取得（画像の場合はalt属性、次にaria-label）
 getElementText(element) {
  const imgElement = element.querySelector("img");
  if (imgElement && imgElement.getAttribute("alt")) {
   return imgElement.getAttribute("alt").trim();
  } else if (element.textContent.trim()) {
   return element.textContent.trim();
  } else if (element.getAttribute("aria-label")) {
   return element.getAttribute("aria-label").trim();
  } else {
   return "";
  }
 }

 // GA4にイベントを送信
 sendEventToGA4(data) {
  if (typeof gtag === "function" && this.isProduction) {
   gtag("event", data.eventName, data.params);
  } else {
   console.log("トラッキングデータ（開発環境）:", data);
  }
 }
}

// スロットリング関数の定義
// 短時間に何度も連続して実行されるのを防ぎ、一定の時間間隔（limit ミリ秒）内では一度だけ実行されるように制御
function throttle(func, limit) {
 let lastFunc;
 let lastRan;
 return function (...args) {
  const context = this;
  if (!lastRan) {
   // 初回実行
   func.apply(context, args);
   lastRan = Date.now();
  } else {
   // 前回の実行からの経過時間が制限時間未満の場合
   clearTimeout(lastFunc);
   lastFunc = setTimeout(
    function () {
     if (Date.now() - lastRan >= limit) {
      func.apply(context, args);
      lastRan = Date.now();
     }
    },
    limit - (Date.now() - lastRan)
   );
  }
 };
}

// GA4クリックトラッカーの初期化
export function initGA4ClickTracker() {
 const tracker = new GA4ClickTracker();
}
